import { Component, OnInit, Input, Output, EventEmitter, ViewEncapsulation, OnDestroy } from '@angular/core';
import { Stage } from '../models/stage.interface';
import { Section } from '../models/section.interface';
import { TranslateService } from '@ngx-translate/core';
import { StageSelectionClass, PagedResult } from '../../_models';
import { SchoolClass } from '../models/schoolClass.interface';
import { BaseComponent } from '../../_base/base.component';
import { MainFiltersInterface } from 'src/app/_services/main-filters.service';
import { ClassesService } from 'src/app/_services/classes/classes-service';
import { AcademicFilter } from './../../_models/academic/acadmeic-filter';
import { ActivatedRoute } from '@angular/router';
import { UserService, SectionsSubjectsService, AssessmentService } from 'src/app/_services';
import { UserBasicInformation } from 'src/app/_models/users/user-basic-information';
import { SectionSubjectLookup } from 'src/app/_models/common/section-subject-lookup.interface';
import { Subscription } from 'rxjs';
import { Lookup } from 'src/app/_models/lookup.interface';

@Component({
  selector: 'app-academic-filter',
  templateUrl: './academic-filter.component.html',
  styleUrls: ['./academic-filter.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class AcademicFilterComponent extends BaseComponent implements OnInit, OnDestroy {
  bsConfig = { containerClass: 'theme-green' };
  // poc ng busy
  // busy: Subscription;
  //
  @Input()
  allowLabels: boolean = false;
  isActive: boolean = true;
  stages: Stage[];
  classes: SchoolClass[] = [];
  sections: Section[] = [];
  academicYearId: number;
  students: UserBasicInformation[] = [];
  subjects: SectionSubjectLookup[] = [];
  assmentCategory: Lookup[]=[];
  stageAndClasses: StageSelectionClass = new StageSelectionClass();
  academicFilterObject: AcademicFilter;
  _parentSubjectId: number = null;
  @Input('turnOnLoader') turnOnLoader: boolean = true;

  @Output('academicFilter')
  filterCriteria: EventEmitter<AcademicFilter> = new EventEmitter();
  @Input('showStudent')
  showStudent: boolean = false;
  @Input('showSubject')
  showSubject: boolean = false;
  @Input('showGradingPriod')
  showGradingPriod: boolean = false;
  @Input('selectDefault')
  selectDefault: boolean = false;
  @Input('columnClass')
  columnClass: string = 'col-lg-3 col-md-6';
  @Input('showMultiStudent')
  showMultiStudent: boolean = false;
  @Input('execludeStudents')
  execludeStudents: UserBasicInformation[] = [];
  @Input('subjectAll')
  subjectAll: boolean = false;

  constructor(
    public translate: TranslateService,
    private _classesService: ClassesService,
    private activatedRoute: ActivatedRoute,
    private _userService: UserService,
    private _sectionsSubjectsService: SectionsSubjectsService,
    private _assmentCategoryServices: AssessmentService
  ) {
    super();
    this.academicFilterObject = new AcademicFilter();
    this.academicFilterObject.component = this;
  }
  @Input('parentSubjectId')
  set parentSubjectId(val: number) {
    this._parentSubjectId = val;
    this.getClassesWhithCheckIfStepBefore();
    this.emitAcademicFilter();
  }
  subscription: Subscription;
  count: number = 0;
  ngOnInit() {
    this.getClassesWhithCheckIfStepBefore();
    this.subscription = this.mainFilterSvc.getMainFilter().subscribe((data: MainFiltersInterface) => {
      this.getClassesWhithCheckIfStepBefore();
    });
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  getSectionsByClassId(classId: number) {
    this.sections = [];
    this.students = [];
    this.assmentCategory =[];
    this.academicFilterObject.assmentCategoryId=null;
    this.academicFilterObject.sectionId = null;
    if (!classId) {
      this.academicFilterObject = new AcademicFilter();
      this.emitAcademicFilter();
      return;
    }

    this.isActive = true;

    this._classesService.getSectionsByClassId(classId).subscribe(
      (data: Section[]) => {
        this.isActive = false;
        if (data.length > 0) {
          this.sections = data;
          if (this.selectDefault && !this.academicFilterObject.sectionId) {
            this.academicFilterObject.sectionId = this.sections.length > 0 ? this.sections[0].sectionId : null;
          }
        }
      },
      () => (this.isActive = false)
    );
  }

  // emit class and section id changes
  emitAcademicFilter() {
    // console.log('obj', this.academicFilterObject);
    this.filterCriteria.emit(this.academicFilterObject);
    this.academicFilterObject.selectedStudents = [];
  }

  setAssmentCategoryFilter(){
    this.emitAcademicFilter();
  }
  // get stages with classes
  getStagesWithClasses() {
    this.academicFilterObject = new AcademicFilter();
    this._classesService.getStagesAndClasses(false, null, this.parentSubjectId).subscribe((data: StageSelectionClass) => {
      this.isActive = false;

      if (!data) return;

      this.stageAndClasses = data;
      const stageGroup = this.stageAndClasses.stages;
      const classes = this.stageAndClasses.classes;
      const isStageEnabled = this.stageAndClasses.isStageEnabled || false;

      this.stages = stageGroup;
      this.classes = classes;

      if (isStageEnabled && this.stageAndClasses.stages.length > 0) {
        stageGroup.map(s => (s.classes = classes.filter(c => c.stageId === s.stageId)));
        if (classes.filter(c => !c.stageId).length > 0) {
          const unknownStages: Stage = {
            stageName: 'UnKnown',
            stageId: -1,
            classes: classes.filter(c => !c.stageId)
          };
          stageGroup.push(unknownStages);
        }
      } else {
        this.classes = this.stageAndClasses.classes;
      }

      // handle select default class and section based on input that passed
      this.getQueryParams();
    });
  }

  isStageView() {
    return this.stageAndClasses.isStageEnabled && this.stageAndClasses.stages.length > 0;
  }

  // set sction and Class Names  to filter that will be  emited
  setClassToFilter(classId: number) {
    if (this.showSubject) {
      this.resetSubject();
    }
    if (classId) {
      this.academicFilterObject.classId = classId;
      const selectedClass = this.classes.length > 0 ? this.classes.find(i => i.classId === classId) : null;
      if (selectedClass) {
        this.academicFilterObject.className = selectedClass.className;
        this.academicFilterObject.classNameEn = selectedClass.classNameEn;
      }
    }

    if (!classId) {
      this.academicFilterObject = new AcademicFilter();
    }
    this.academicFilterObject.sectionId = null;
    this.academicFilterObject.studentId = null;
    this.emitAcademicFilter();
  }

  setSectionToFilter(sectionId: number) {
    this.academicFilterObject.studentId = null;
    this.resetSubject();
    if (sectionId) {
      this.academicFilterObject.sectionId = sectionId;
      const selectedSection = this.sections.length > 0 ? this.sections.filter(i => i.sectionId === sectionId)[0] : null;

      if (selectedSection) {
        this.academicFilterObject.sectionName = selectedSection.sectionName;
        this.academicFilterObject.sectionNameEn = selectedSection.sectionNameEn;
      }
      // call method that return subjects and students related to this section
      if (this.showStudent || this.showMultiStudent) {
        this.getStudentsBySection(sectionId);
      }
      if (this.showSubject) {
        this.getSubjectsBySection(sectionId);
      }
      // end check and bind student and subject
      this.emitAcademicFilter();
      return;
    }

    this.academicFilterObject.sectionId = null;
    this.academicFilterObject.sectionName = null;
    this.academicFilterObject.sectionNameEn = null;
    this.emitAcademicFilter();
  }

  setSubjectToFilter() {
    if (!this.academicFilterObject.sectionSubjectId && this.subjectAll) {
      this.emitAcademicFilter();
    }
  
    if (!this.academicFilterObject.sectionSubjectId){  this.emitAcademicFilter();  return;}

    const selectedSubject = this.subjects.find(s => s.sectionSubjectId === this.academicFilterObject.sectionSubjectId);
    if (!selectedSubject) { this.emitAcademicFilter();  return;}

    this.academicFilterObject.sectionSubjectName = selectedSubject.subjectName;
    this.academicFilterObject.sectionSubjectNameEn = selectedSubject.subjectNameEn;

    this.emitAcademicFilter();
  }


  // handle get query params
  getQueryParams() {
    const classId = parseInt(this.activatedRoute.queryParams['value']['classId'], 10);
    const sectionId = parseInt(this.activatedRoute.queryParams['value']['sectionId'], 10);
    if (classId) {
      this.academicFilterObject.classId = classId;
      this.getSectionsByClassId(classId);
      if (sectionId) {
        this.academicFilterObject.sectionId = sectionId;
      }
      this.emitAcademicFilter();
      return;
    }
    // select default class and section based on input select default input
    if (this.selectDefault) {
      this.academicFilterObject.classId = this.classes.length > 0 ? this.classes[0].classId : null;
      this.academicFilterObject.classId ? this.getSectionsByClassId(this.academicFilterObject.classId) : (function emptyCall() {})();
    }
  }
  // get students and subjects by sectionId
  getStudentsBySection(sectionId: number) {
    // observe that we passed page index and page size to get all student
    this._userService.getStudents(0, 70, null, sectionId).subscribe((data: PagedResult<UserBasicInformation>) => {
      if (data) {
        this.students = data.results;
      }
    });
  }

  getSubjectsBySection(sectionId: number) {
    this.assmentCategory =[];
    this.academicFilterObject.assmentCategoryId=null;
    this._sectionsSubjectsService.getAllBySection(sectionId).subscribe((data: SectionSubjectLookup[]) => {
      if (data.length > 0) {
        this.subjects = data;
      }
    });
  }

  handleSelectedStudent() {
    this.academicFilterObject.selectedStudents = [];
    if (this.academicFilterObject.studentIds.length > 0) {
      this.academicFilterObject.studentIds.map(s => {
        this.students.map(i => {
          if (i.id === s) {
            this.academicFilterObject.selectedStudents.push(i);
          }
        });
      });
    }
    this.emitAcademicFilter();
  }

  isExeclude(studentId: string) {
    return this.execludeStudents.filter(i => i.id === studentId).length > 0;
  }

  resetSubject() {
    this.subjects = [];
    this.academicFilterObject.sectionSubjectId = null;
  }

  resetFilter() {
    this.academicFilterObject = new AcademicFilter();
    this.academicFilterObject.component = this;
    this.emitAcademicFilter();
  }

  getClassesWhithCheckIfStepBefore() {
    if (this._parentSubjectId === -1) {
      this.stages = [];
      this.classes = [];
      this.sections = [];
      this.academicFilterObject.classId = null;
      this.academicFilterObject.sectionId = null;
      this.isActive = false;
    } else {
      this.getStagesWithClasses();
    }
  }

  getAssmentCategory(){
    // this.assmentCategory =[];
    // this.academicFilterObject.assmentCategoryId=null;
    this._assmentCategoryServices.GetAssessmentCategoriesLookup(this.academicFilterObject.sectionSubjectId).subscribe((data: Lookup[]) => {
      if (data.length > 0) {
        this.assmentCategory = data;
      }
    });
  }
}
